import http from '../request'
// 获取书籍列表数据
export const getBookList = params => {
    return http.get('/api/book', { params })
}
